import { useQuery } from '@graphcommerce/graphql'
import { i18n } from '@lingui/core'
import { Button } from '@mui/material'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { PrimaryButton, SecondaryButton } from '../../Button'
import { FileUploadModal, ProofOptionEnum, s3File } from '../../FileUpload/FileUploadModal'
import { Spinner } from '../../Spinner'
import { ArtworkPreflightDocument } from './ArtworkPreflight.gql'
import { ArtworkPreflightResult } from './ArtworkPreflightResult'
import { ArtworkRequirementsDocument } from './ArtworkRequirements.gql'

type ArtworkRequirementsProps = {
  productUuid?: string
  enteredOptions: string[]
  setArtworkFiles: Dispatch<
    SetStateAction<
      (s3File & {
        type?: string | undefined
      })[]
    >
  >
  artworkFiles: (s3File & {
    type?: string | undefined
  })[]
  setArtworkComment?: Dispatch<SetStateAction<string>>
  artworkComment?: string | null
  setProofOption?: Dispatch<SetStateAction<ProofOptionEnum>>
  proofOption?: ProofOptionEnum
  callback?: () => void
}

export function ArtworkRequirements(props: ArtworkRequirementsProps) {
  const {
    productUuid,
    enteredOptions,
    artworkFiles,
    setArtworkFiles,
    artworkComment,
    proofOption,
    setArtworkComment,
    setProofOption,
    callback,
  } = props

  const { data, loading } = useQuery(ArtworkRequirementsDocument, {
    variables: {
      productUuid: productUuid || '',
      enteredOptions,
    },
    fetchPolicy: 'cache-and-network',
  })

  // const {
  //   data: preflightData,
  //   refetch: updatePreflightData,
  //   loading: preflightLoading,
  // } = useQuery(ArtworkPreflightDocument, {
  //   variables: {
  //     files: artworkFiles.map((f) => ({ path: f.url })),
  //   },
  //   fetchPolicy: 'cache-and-network',
  //   skip: !artworkFiles.length,
  // })

  const files = data?.fourOverProductArtworkRequirements

  // useEffect(() => {
  //   updatePreflightData()
  //     .then(() => {})
  //     .catch(() => {})
  // }, [files, updatePreflightData])

  const [isDisplayFileUploadModal, setIsDisplayFileUploadModal] = useState<boolean | string>(false)

  if (loading) {
    return (
      <div className='my-[20px] text-center'>
        <Spinner />
      </div>
    )
  }

  if (!files || files.length === 0) return null

  return (
    <div className='my-[20px]'>
      {files.map((file) => (
        <div key={file?.code}>
          <div className='mb-5'>
            {!file || !file.code || !artworkFiles.find((f) => f.type === file.code)?.url ? (
              <PrimaryButton
                className='w-full bg-bright-templi-purple'
                onClick={() => setIsDisplayFileUploadModal(file?.code || false)}
                size='small'
              >
                {`${i18n._('Upload Artwork')} (${file?.title})` || ''}
              </PrimaryButton>
            ) : (
              <SecondaryButton
                className='w-full border-bright-templi-purple text-bright-templi-purple'
                onClick={() => setIsDisplayFileUploadModal(file?.code || false)}
              >
                {i18n._('View Artwork')}
              </SecondaryButton>
            )}
            {!!artworkFiles.find((f) => f.type === file && file.code) && (
              <Button
                variant='outlined'
                color='primary'
                className='w-full rounded-[5px] uppercase'
                onClick={() => {
                  setArtworkFiles(artworkFiles.filter((f) => f.type !== file?.code))
                }}
              >
                {i18n._('Discard')}
              </Button>
            )}

            {/* <ArtworkPreflightResult
              loading={preflightLoading}
              result={preflightData?.fourOverProductArtworkPreflight?.files?.find(
                (f) =>
                  f &&
                  f.path ===
                    artworkFiles.find((artFile) => file && artFile.type === file.code)?.url,
              )}
            /> */}
          </div>
          <FileUploadModal
            modalId={`fileUploadModal-${file?.code}`}
            isDiplayed={isDisplayFileUploadModal === file?.code}
            setIsDisplayed={(v) => setIsDisplayFileUploadModal(false)}
            setUploadedFile={(uploadedFiles, type) => {
              const filesWithType = uploadedFiles.map((uploadedFile) => ({
                ...uploadedFile,
                type: type || uploadedFile.type || file?.code || '',
              }))
              // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
              const updatedArtworks = [
                ...artworkFiles.filter((f) => f.type !== file?.code),
                ...filesWithType,
              ]
              // If no artwork has been uploaded, we still push its object, so that we can disable add to cart button
              const typesWithoutArtwork = files
                .map((file) => file?.code)
                .filter((code) => !updatedArtworks.find((f) => f.type === code))
              if (typesWithoutArtwork) {
                typesWithoutArtwork.forEach((type) => {
                  updatedArtworks.push({ type })
                })
              }
              setArtworkFiles(updatedArtworks)
            }}
            files={artworkFiles.filter((f) => f?.url && f.type === file?.code)}
            type={file?.code || ''}
            artworkComment={artworkComment}
            setArtworkComment={setArtworkComment}
            proofOption={proofOption}
            setProofOption={setProofOption}
            callback={callback}
          />
        </div>
      ))}
    </div>
  )
}
